const brandPaymentMethods: string = import.meta.env.VITE_BRAND_PAYMENTS_METHODS ?? ''

const supportedPaymentMethods = [
  {
    title: 'mastercard',
    icon: '/icons/payments/mastercard.svg',
  },
  {
    title: 'kaspi',
    icon: '/icons/payments/kaspi.svg',
  },
  {
    title: 'visa',
    icon: '/icons/payments/visa.svg',
  },
  {
    title: 'sbp',
    icon: '/icons/payments/sbp.svg',
  },
  {
    title: 'mir',
    icon: '/icons/payments/mir.svg',
  }
]

const paymentMethodsMap = Object.fromEntries(
  supportedPaymentMethods.map(p => [ p.title, p ])
)

export const PAYMENTS = {
  title: 'payment_systems',
  items: brandPaymentMethods
    .split(',')
    .map(method => paymentMethodsMap[method.trim()])
    .filter(Boolean),
}
